import React from "react";
import { ContentSection } from "sprint-common-web";

import { RecordType } from "../../../../../../common/types/RecordType";
import { useFileRecordDetailsState } from "../../../hooks/useFileRecordDetailsState";
import { AudioFileRecordTechnicalSection } from "./audio/AudioFileRecordTechnicalSection";
import { VideoFileRecordTechnicalSection } from "./video/VideoFileRecordTechnicalSection";

export const FileRecordTechnicalSection = (): JSX.Element => {
    const { fileRecordDetails, isLoading } = useFileRecordDetailsState();

    switch (fileRecordDetails.type) {
        case RecordType.Video:
            return <VideoFileRecordTechnicalSection />;

        case RecordType.Audio:
            return <AudioFileRecordTechnicalSection />;

        case RecordType.Subtitle:
            return <></>;

        default:
            return <ContentSection header="Technical" isLoading={isLoading} style={{ height: 300 }} />;
    }
};
